import { fetchUtils } from 'react-admin';
import JsonServerProvider from 'ra-data-json-server';
import ReactGA from 'react-ga';

import Environment from './Constants/Environment';
import ServerUrl from './Constants/ServerUrl';

ReactGA.initialize('UA-38628993-2')

type OptionsTypes = {
  headers?: Headers
};

const HttpClient = (url, options: OptionsTypes = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = localStorage.getItem('token');
  options.headers.set('Authorization', `Bearer ${token}`);

  if (Environment === 'PRODUCTION') {
    const userId = localStorage.getItem('user_id');
    if (userId) {
      ReactGA.set({ userId: userId });
    }
    let address = url.replace(ServerUrl, '');
    ReactGA.pageview(address);
  }
  return fetchUtils.fetchJson(url, options);
}

const ConvertFileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file.rawFile);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

const AddUploadCapabilities = requestHandler => (type, resource, params) => {
  if (type === 'UPDATE' && resource === 'campaign_sites') {
    if (params.data.ad_campaign && params.data.ad_campaign.creatives_attributes) {
      var uploads = [];

      params.data.ad_campaign.creatives_attributes.forEach((creative) => {
        if (creative.image && creative.image.length) {
          uploads.push(creative.image[0]);
        }
      });

      return Promise.all(uploads.map(ConvertFileToBase64))
        .then(base64Uploads => base64Uploads.map(upload64 => {
          return {
            src: upload64
          }
        }))
        .then(transformedNewUploads => requestHandler(type, resource, {
          ...params,
          data: {
            ...params.data,
            uploads: [...transformedNewUploads]
          },
        }));
    }
  }

  return requestHandler(type, resource, params);
};

const RestClient = AddUploadCapabilities(JsonServerProvider(ServerUrl + '/api/v3', HttpClient));

export default RestClient;



// WEBPACK FOOTER //
// ./src/views/Framework/RestClient.tsx